export default "__VITE_ASSET__Dp45iz1Q__"